import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import "hammerjs";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr";

import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";
import { CoreModule } from "@core/core.module";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";

import { coreConfig } from "./app-config";
import { AppComponent } from "./app.component";
import { LayoutModule } from "../../../../src/app/layout/layout.module";
import { ModalWrapperModule } from "app/components/modal-wrapper/modal-wrapper.module";
import { environment } from "environments/environment";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: `${environment.urlIAM}`,
        realm: `${environment.realm}`,
        clientId: `${environment.clientId}`,
      },
      enableBearerInterceptor: true,
      initOptions: {
        onLoad: "login-required",
        redirectUri: window.location.href,
        checkLoginIframe: false,
      },
    });
}

const appRoutes: Routes = [
  {
    path: "pages",
    loadChildren: () =>
      import("../../../../src/app/main/pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./main/smartcity/smartcity.module").then((m) => m.SmartcityModule),
  },
  {
    path: "**",
    redirectTo: "/pages/miscellaneous/error",
  },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled",
      relativeLinkResolution: "legacy",
      preloadingStrategy: PreloadAllModules,
    }),
    TranslateModule.forRoot(),

    NgbModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      timeOut: 3000,
      progressBar: true,
      closeButton: true,
    }),
    NgxDatatableModule.forRoot({
      messages: {
        emptyMessage: "Không có dữ liệu",
        totalMessage: "Hàng",
        selectedMessage: "Đã chọn",
      },
    }),
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    LayoutModule,
    ModalWrapperModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
